export default __webpack_public_path__ + "static/media/band2.8091a022.jfif";